import { gql } from '@apollo/client';

/**
 * Query to fetch the Universal Worklist items
 */
export const UniversalWorklistQuery = gql`
  query WorklistItemsPaged($filter: UwlWorklistFilter) {
    devhub {
      universalWorklist {
        worklistItemsPaged(filter: $filter) {
          worklistItems {
            actionUrl
            assignedTo {
              ... on User {
                login
              }
              ... on Group {
                name
              }
              ... on UwlWorklistRoleAssignment {
                applications {
                  applicationId
                  name
                }
                role {
                  displayName
                }
              }
            }
            category {
              code
              name
            }
            description
            dueDate
            id
            name
            priority
            source
            status
            supportUrl
          }
        }
      }
    }
  }
`;
